import React, { Component } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Row } from 'reactstrap';
import NumberFormat from 'react-number-format';

class EditPhysicalAddress extends Component {
  state = {
    disabled: true
  }

  handleValueChange = () => {
    this.setState({ disabled: false })
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="md">
        <ModalHeader toggle={this.props.toggle}>Edit Physical Address</ModalHeader>
        <ModalBody>

          <FormGroup>
            <Label for="addressLine1">Address Line 1</Label>
            <Input
              type="text"
              name="address-line-1"
              id="addressLine1"
              defaultValue="15303 Ventura Blvd"
              onChange={this.handleValueChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="addressLine2">Address Line 2</Label>
            <Input
              type="text"
              name="address-line-2"
              id="addressLine2"
              onChange={this.handleValueChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="addressCity">City</Label>
            <Input
              type="text"
              name="address-city"
              id="addressCity"
              defaultValue="Sherman Oaks"
              onChange={this.handleValueChange}
            />
          </FormGroup>

          <Row>
            <Col xs={6}>
              <FormGroup>
                <Label for="addressState">State</Label>
                <Input
                  type="select"
                  name="address-state"
                  id="addressState"
                  defaultValue="California"
                  onChange={this.handleValueChange}
                >
                  <option value="">Select...</option>
                  <option value="California">California</option>
                  <option value="Illinois">Illinois</option>
                </Input>
              </FormGroup>
            </Col>
            <Col xs={6} className="pl-0">
              <FormGroup>
                <Label for="addressZip">Zip Code</Label>
                <Input
                  type="tel"
                  name="address-zip"
                  id="addressZip"
                  tag={NumberFormat}
                  format="#####"
                  defaultValue="91403"
                  onChange={this.handleValueChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Button color="primary" className="w-100 mt-1" disabled={this.state.disabled}>Save</Button>

        </ModalBody>
      </Modal>
    );
  }
}

export default EditPhysicalAddress;
